import { Card, CardContent, Grid, TextField, Typography, Button } from '@mui/material';
import api from '../../services/api';
import { useState } from 'react';
import Notification from '../../components/Notification/Notification';
import { toBase64 } from '../utils/toBase64';
import { FaEdit } from 'react-icons/fa'
import useWindowDimensions from '../../components/Sidebar/WindowDimensions';
import { updateImage } from '../utils/updateImage';


export default function GroupRegister({ refresh, setRefresh }) {

  const { width } = useWindowDimensions();

  const [nameSecretary, setNameSecretary] = useState('');
  const [nameForCitizen, setNameForCitizen] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState();
  const [inputIcon, setInputIcon] = useState(null);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' });

  const classes = {
    root: {
      flexGrow: 1,
      margin: 20,
      marginTop: 30,
      borderRadius: '17px',
      backgroundColor: '#F5F5F5',
      boxShadow: 'none',
    },
    fullWidth: {
      width: '100%',
    },
    inputFile: {
      border: 'dashed 2px #BABABA',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 10,
      height: 55.972,
      borderRadius: 5,
      padding: '13px 10px',
      textAlign: 'center',
      fontFamily: 'Rawline',
      backgroundColor: 'white'
    },
    input: {
      backgroundColor: 'white',
    },
    btnSubmit: {
      backgroundColor: '#FFD700',
      borderColor: 'rgba(0,0,0,0.21)',
      color: 'black',
      height: 45,
    },
    textTitle: {
      margin: 8,
      color: '#103168',
      fontWeight: 600,
      marginBottom: 30,
    },
    message: {
      padding: 10,
      backgroundColor: '#FFFBE8',
      color: 'rgba(0,0,0,0.8)',
      borderRadius: 7,
      width: '100%'
    },
    buttonConfirm: {
      backgroundColor: '#1551B3',
      color: '#fff',
      borderRadius: 20,
      height: '45px',
      textTransform: 'capitalize',
      fontWeight: 'bold',
      fontSize: 15,
      marginTop: '17px',
      minWidth: '220px'
    },
    labelInput: {
      fontFamily: 'Rawline',
      color: '#333333',
      fontWeight: 'bold',
      paddingLeft: 2,
      fontSize: 14,
      marginBottom: '0.5rem'
    },
    heightAdjust: {
      height: (width > 900 && 1220 > width ? 42 : 'auto')
    },
  }


  const handleSubmit = (e) => {
    e.preventDefault();

    toBase64(icon).then((base64) => {

      const data = {
        nameSecretary,
        nameForCitizen,
        description,
        picture: {
          type: icon.type,
          body: base64,
          url: ""
        },
        priority: "Comum"
      };

      api.post('/groups', data)
        .then((response) => {
          setNotify({
            isOpen: true,
            message: 'Grupo cadastrado com sucesso.',
            type: 'success',
            title: 'Cadastrada'
          });
          clearFields();
          setRefresh(true);
        })
        .catch((err) => {
          setNotify({
            isOpen: true,
            message: 'O sistema apresentou um erro no cadastro',
            type: 'error',
            title: 'Erro'
          });
        })

    });
  }


  const clearFields = () => {
    setNameSecretary('')
    setDescription('')
    setNameForCitizen('')
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Card style={classes.root}>
          <CardContent>
            <Grid id='form-inputs' container spacing={2} alignItems="center" justifyContent="center">
              <Grid item xs={12} sm={12} lg={12}>
                <Typography variant="h5" align="center" style={classes.textTitle}>
                  Cadastro de Grupos
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} lg={12}>
                <div style={classes.message}>
                  Preencha o formulário abaixo para cadastrar um grupo de ocorrências.
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4}>
                <Typography style={{ ...classes.labelInput, ...classes.heightAdjust }}>
                  Nome do Grupo da Secretaria: *
                </Typography>

                <TextField
                  style={classes.input}
                  fullWidth
                  required
                  value={nameSecretary}
                  onChange={(e) => setNameSecretary(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4}>
                <Typography style={{ ...classes.labelInput, ...classes.heightAdjust }}>
                  Nome do Grupo do Cidadão: *
                </Typography>

                <TextField
                  style={classes.input}
                  fullWidth
                  required
                  value={nameForCitizen}
                  onChange={(e) => setNameForCitizen(e.target.value)}
                />
              </Grid>

              <Grid style={{position:'relative'}} item xs={12} sm={12} md={4} lg={4}>
                <div style={classes.labelInput}>Selecione um ícone para este grupo</div>
                <div style={classes.inputFile}>
                  <div style={{display:'flex', alignItems: 'center', justifyContent:'center', width: '100%', gap: '10px'}}>
                    <input
                      style={{width: '80%'}}
                      accept="image/*"
                      label='Icone'
                      type='file'
                      onChange={(e) => {
                        updateImage(e.target.files[0], setInputIcon); 
                        setIcon(e.target.files[0])
                      }}
                    />
                    <div style={{width: '20%'}}>
                      <img src={inputIcon} width={30} height={30}/>
                    </div>
                  </div>
                </div>
            </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography style={classes.labelInput}>
                  Descrição: *
                </Typography>

                <TextField
                  style={{ ...classes.input, zIndex: 0 }}
                  multiline
                  rows={4}
                  fullWidth
                  required
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item>
            <Button
              id='register-button'
              variant="outlined"
              type='submit'
              startIcon={<FaEdit style={{ 'color': '#fff' }} />}
              style={classes.buttonConfirm}
            >
              Cadastrar
            </Button>
          </Grid>
        </Grid>


      </form>

      <Notification
        notify={notify}
        setNotify={setNotify}
      />
    </div >
  );

}